import { createFileRoute } from "@tanstack/react-router";
import { PipelineDetail } from "../../features/runs/pipeline-detail";

export const Route = createFileRoute("/_authed/$org/$project/pipelines/$name/$tab")({ component: PipelinePage });

function PipelinePage() {
  const { org, project, name, tab } = Route.useParams();
  return <PipelineDetail scope={{ org, project }} name={name} tab={tab} />;
}
